import React, { useEffect, useState } from "react";
import MapContainer from "../MainMap/MainMap";
import * as actions from "../../../store/actions/index";
import { connect } from "react-redux";
import { createPoints } from "../../../shared/utility";
import "./BigMap.css";
import axiosConfig from "../../../axiosConfig";
import { Card, CardBody } from "../../../shared/Card/Index";

function Maps(props) {
  const { isAuth, editMapPoint, editMapState } = props;

  useEffect(() => {
    if (isAuth) {
      axiosConfig
        .get("/Beneficiary/GetModelForMap")
        .then((res) => {
          let pointsFromDatabase = res.data;

          editMapState(
            {
              pointsStore: createPoints(pointsFromDatabase),
              alertForAlertsTable: [],
            },
            editMapPoint,
            editMapState
          );
        })
        .then(() => {});
    }
  }, []);

  return (
    <div className="BigMap" style={{ height: "100%" }}>
      <div className="home_title">
          Χάρτης
      </div>
      <Card style={{ height: "98vh" }}>
        <CardBody >
          <MapContainer />
        </CardBody>
      </Card>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    ...state.auth,
    ...state.map,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editMapPoint: (mapPointCoordinates, pointsStore, url, mapObject) => {
      dispatch(
        actions.editMapPointAsync(
          mapPointCoordinates,
          pointsStore,
          url,
          mapObject
        )
      );
    },
    editMapState: (mapPayload) => {
      dispatch(actions.editMapStateAsync(mapPayload))
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Maps);
